import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { TearOutState } from './tearOut.types';

import { TearOutModel } from '~/core/models';
import { decById, incById } from '~/core/utils';

const initialState: TearOutState = {
  selectedTearOuts: {},
};

const tearOutSlice = createSlice({
  name: 'tearOut',
  initialState,
  reducers: {
    resetSelectedTearOuts: (state) => {
      state.selectedTearOuts = initialState.selectedTearOuts;
    },
    updateSelectedTearOuts: (
      state,
      { payload }: PayloadAction<TearOutState['selectedTearOuts']>
    ) => {
      state.selectedTearOuts = payload;
    },
    updateSelectedTearOut: (
      state,
      {
        payload: { id, qty },
      }: PayloadAction<{ id: TearOutModel['productId']; qty: number }>
    ) => {
      state.selectedTearOuts[id] = qty;
    },
    increaseSelectedTearOuts: (
      state,
      { payload: id }: PayloadAction<TearOutModel['productId']>
    ) => {
      state.selectedTearOuts = incById(state.selectedTearOuts, id);
    },
    decreaseSelectedTearOuts: (
      state,
      { payload: id }: PayloadAction<TearOutModel['productId']>
    ) => {
      state.selectedTearOuts = decById(state.selectedTearOuts, id);
    },
    removeSelectedTearOut: (
      state,
      { payload: id }: PayloadAction<TearOutModel['productId']>
    ) => {
      delete state.selectedTearOuts[id];
    },
  },
});

export const {
  decreaseSelectedTearOuts,
  increaseSelectedTearOuts,
  updateSelectedTearOut,
  updateSelectedTearOuts,
  resetSelectedTearOuts,
  removeSelectedTearOut,
} = tearOutSlice.actions;

export default tearOutSlice.reducer;
